// utils/socialMediaUtils.js
import InstagramIcon from '../components/Icons/InstagramIcon';
import FacebookIcon from '../components/Icons/FacebookIcon';
import TiktokIcon from '../components/Icons/TiktokIcon';
import YoutubeIcon from '../components/Icons/YoutubeIcon';
import XtwitterIcon from '../components/Icons/XtwitterIcon';
import LinkIcon from '../components/Icons/LinkIcon';
// Función para determinar la plataforma en base a la URL
export const getPlatform = (url) => {
  if (url.includes('instagram.com')) return 'Instagram';
  if (url.includes('facebook.com')) return 'Facebook';
  if (url.includes('tiktok.com')) return 'TikTok';
  if (url.includes('youtube.com')) return 'YouTube';
  if (url.includes('twitter.com') || url.includes('x.com')) return 'X';
  return 'Link';
};

// // Función para obtener el ícono en base a la plataforma
// export const getIcon = (platform) => {
//   switch (platform) {
//     case 'Instagram':
//       return '/icons/instagram.svg';
//     case 'Facebook':
//       return '/icons/facebook.svg';
//     case 'TikTok':
//       return '/icons/tiktok.svg';
//     case 'YouTube':
//       return '/icons/youtube.svg';
//     case 'X':
//       return '/icons/x.svg';
//     default:
//       return '/icons/link.svg';
//   }
// };

// Función para obtener el ícono en base a la plataforma
export const getIcon = (platform) => {
  switch (platform) {
    case 'Instagram':
      return InstagramIcon; // Return component
    case 'Facebook':
      return FacebookIcon; // Return component
    case 'TikTok':
      return TiktokIcon; // Return component
    case 'YouTube':
      return YoutubeIcon; // Return component
    case 'X':
      return XtwitterIcon; // Return component
    default:
      return LinkIcon; // Return component
  }
};